import { Grid, Typography } from '@mui/material'
import React from 'react'
import { KaziCard } from '../../../Shared Components/Kazi/Cards/KaziCard'
import { useGetClientQuery } from '../../../Redux/api/clientApi';
import { useAppSelector } from '../../../Redux/store';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetManyTalentsQuery } from '../../../Redux/api/talentApi';
import { KaziTalentCard } from '../../../Shared Components/Kazi/Cards/KaziTalentCard';
import { Talent } from '../../../Types/Talent';

interface IClientBookmarksProps {
    talents?: Talent[]
}
export const ClientBookmarks = ({ talents }: IClientBookmarksProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={'flex'} flexDirection={'column'}>
            <Typography variant='lora-headline-small'>Bookmarked Talent</Typography>
            <Grid display={'grid'} gridTemplateColumns={'repeat(3, 388px)'} marginTop={3} columnGap={4}>
                {
                    talents?.map((talent, idx) =>(
                        <Grid key={`${talent?.first_name}-${talent?.last_name}-${idx}`}> 
                            <KaziTalentCard talent={talent} sx={{height: "100%"}}/>
                        </Grid> 
                    ))
                }
            </Grid>
        </Grid>
    )
}